export const BUY_NOW_LABEL = "Buy now price";
export const BUY_NOW_SUB_LABEL =
  "This is the price collectors can instantly buy each edition at.";

export const STARTING_PRICE_LABEL = "Starting price";
export const STARTING_PRICE_PLACEHOLDER = "Enter starting price";
export const STARTING_PRICE_SUB_LABEL =
  "This is the price of the first edition.";

export const PRICE_INCREMENT_LABEL = "Price increment";
export const PRICE_INCREMENT_PLACEHOLDER = "Enter price increment";
export const PRICE_INCREMENT_SUB_LABEL =
  "This is how much each newly minted edition will go up in price.";
